import { useAuthUserData, useUserOrganisations } from '../../../../authUserProvider'

export const MHL_AGENT_ORG = 'Military Hearing Loss'
export const MHL_ADMIN_ORG = 'Military Hearing Loss Admin'

// Named users (lowercase emails) who may overturn a review decision in
// addition to admins. Mirrors MHL_REVIEW_OVERTURN_EMAILS in the backend
// (case-delivery-app militaryHearingLossScope.js) — keep the lists in sync.
export const MHL_REVIEW_OVERTURN_EMAILS = ['dan@sentinelleagle.co.uk']

/**
 * Resolves the current user's MHL role. Mirrors the backend gates:
 *   - `isMhlAdmin`: Sentinel staff, the MHL Admin org, or a membership grant of it
 *   - `isMhlUser`:  any of the above, or the MHL agent org
 *   - `canOverturnReview`: admins or the named overturn users only — may
 *     change a rejected client back to approved
 */
export const useMhlAccess = () => {
    const authUser = useAuthUserData()
    const { organisations } = useUserOrganisations()
    const primary = authUser?.['custom:organisation'] || ''
    const orgs = organisations.length ? organisations : primary ? [primary] : []
    const isAdminFlag = authUser?.['custom:admin'] === 'true' || authUser?.['custom:admin'] === '1'

    const isSentinel = orgs.includes('Sentinel') || isAdminFlag
    const isMhlAdmin = isSentinel || orgs.includes(MHL_ADMIN_ORG)
    const isMhlUser = isMhlAdmin || orgs.includes(MHL_AGENT_ORG)
    const canOverturnReview = isAdminFlag || MHL_REVIEW_OVERTURN_EMAILS.includes((authUser?.email || '').trim().toLowerCase())

    return {
        isSentinel,
        isMhlAdmin,
        isMhlUser,
        canOverturnReview,
        email: authUser?.email || '',
        name: authUser?.name || '',
        cognitoId: authUser?.sub || '',
        organisation: primary,
    }
}
